import React from 'react';
interface LogoProps {
  className?: string;
  variant?: 'dark' | 'light';
}
const JAG_LOGO_URL = 'https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/wZmCOMOYUn4CfsoCHQM0/media/699617b9905d472601bbd7ed.svg';
export function Logo({
  className = '',
  variant = 'dark'
}: LogoProps) {
  const isFooter = variant === 'light';
  return <div className={`relative shrink-0 overflow-hidden ${isFooter ? 'h-[78px] w-[360px]' : 'h-[66px] w-[340px]'} ${className}`} data-id="element-130" data-mp="msuqq7mm83ev">
      <img src={JAG_LOGO_URL} alt="JAG Medical Solutions" className={`absolute left-1/2 top-1/2 h-auto max-w-none -translate-x-1/2 -translate-y-[47%] ${isFooter ? 'w-[360px]' : 'w-[340px]'}`} data-id="element-131" data-mp="rqwakurv86re" />
    </div>;
}